<div id="app-info-trigger" (click)="appInfoClick()"></div>
<div class="fab-content-container" *ngIf="showFabContent" (click)="$event.stopPropagation()" [@openClose]="showFabContent ? 'open' : 'closed'">
  <ul class="list-item cp" *ngIf="showHelpButton()" (click)="onClickInfo()">
    <h4 class="title d-flex justify-content-start align-items-center gap-10 mb-10">
      <span class="icon-help-1"></span>
      <span class="title-text">Help</span>
    </h4>
    <div class="description">Click here to access information.</div>
  </ul>
  <ul class="list-item cp" *ngIf="showDocumentaion()" (click)="onClickDocumentation()">
    <h4 class="title d-flex justify-content-start align-items-center gap-10 mb-10">
      <span class="fa fa-book"></span>
      <span class="title-text">Documentation</span>
    </h4>
    <div class="description">Click here to access our Customer Documentation and learn more about our Testing Platform.</div>
  </ul>
  <ul class="list-item cp" (click)="onClickWatchDemo()">
    <h4 class="title d-flex justify-content-start align-items-center gap-10 mb-10">
      <span class="icon-video"></span>
      <span class="title-text">Watch tutorial</span>
    </h4>
    <div class="description">Click here to watch our video tutorials for the SMS Testing Platform.</div>
  </ul>
  <ul *ngIf="!currentUser || !currentUser.impersonated" class="list-item cp" (click)="openFreshChat()">
    <div class="manager-container">
      <div class="d-flex justify-content-start align-items-start gap-15 mb-15">
        <img class="icon-support" src="/img/support.svg" alt="" />
        <span class="manager-title">Chat with TelQ</span>
      </div>
      <div>
        <p class="info">Contact our team for any technical, commercial and other queries.</p>
      </div>
    </div>
  </ul>
</div>

<button
  class="btn btn-primary fab"
  *ngIf="showFabButton"
  (click)="showFabContent = !showFabContent; $event.stopPropagation()"
  [ngClass]="showFabContent ? 'active' : ''"
  [@openClose]="showFabButton ? 'open' : 'closed'">
  <span [ngClass]="{ 'icon-help': !showFabContent, 'icon-close': showFabContent }"></span>
</button>

<ng-template #liveTestingModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Live Number Testing Information</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="d-flex gap-15">
      <div class="dlr-status">
        <h3>DLR Status</h3>
        <ul class="status d-flex flex-column my-15 gap-10">
          <li><i class="far fa-smile text-success-s2"></i> Delivered</li>
          <li><i class="far fa-smile text-accent-a2"></i> Partially delivered</li>
          <li><i class="far fa-meh text-accent-a2"></i> Accepted/Pending/Scheduled</li>
          <li><i class="far fa-meh text-accent-a2"></i> Enroute/Unknown</li>
          <li><i class="far fa-frown text-accent-a2"></i> No DLR received</li>
          <li><i class="far fa-frown error text-error-r3"></i> Expired/Deleted/Undeliverable</li>
          <li><i class="far fa-frown error text-error-r3"></i> Rejected/Skipped/SUBMIT_SM failed</li>
        </ul>
      </div>
      <div class="receipt-status">
        <h3>Receipt Status</h3>
        <ul class="status d-flex flex-column my-15 gap-10">
          <li><i class="icon-wait spin"></i> Wait</li>
          <li><i class="icon-positive text-success-s2"></i> Positive</li>
          <li><i class="icon-rcs-positive text-success-s2"></i> RCS Positive</li>
          <li><i class="icon-test-number-not-available text-accent-a2"></i> Test number not available</li>
          <li><i class="icon-network-offline text-error-r3"></i> Network offline</li>
          <li><i class="icon-negative text-accent-a2"></i> Test number offline</li>
          <li><i class="icon-attention text-accent-a2"></i> Text or Sender ID replaced</li>
          <li><i class="icon-rcs-text-replaced text-accent-a2"></i> RCS Text or Sender ID replaced</li>
          <li *ngIf="showFlashCallHelp"><i class="icon-flash-call"></i> Flash call</li>
          <li><i class="icon-negative text-accent-a2"></i> Negative</li>
          <li><i class="icon-bug-red text-error-r3 ms-0_2"></i> Internal error</li>
          <li><i class="icon-smpp-connection-offline text-error-r3"></i> SMPP Connection offline</li>
        </ul>
      </div>
    </div>

    <div class="receipt-statuses">
      <h3>Receipt status</h3>
      <div class="accordion mt-20" id="accordionReceiptStatus">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseWait"
              aria-expanded="true"
              aria-controls="collapseWait">
              <i class="icon-wait spin"></i> Wait
            </button>
          </h2>
          <div id="collapseWait" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>
                TelQ’s system is still waiting to receive the test number’s confirmation that the SMS with the Test ID text assigned to the request
                has been delivered to the handset (this is the default Rec. status).
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsePositive"
              aria-expanded="true"
              aria-controls="collapsePositive">
              <i class="icon-positive text-success-s2"></i> Positive
            </button>
          </h2>
          <div id="collapsePositive" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>The SMS has been delivered to our test number with Sender and Text as submitted.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseRcsPositive"
              aria-expanded="true"
              aria-controls="collapseRcsPositive">
              <i class="icon-rcs-positive text-success-s2"></i> RCS Positive
            </button>
          </h2>
          <div id="collapseRcsPositive" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>
                The RCS message has been delivered to our test number with Sender and Text as submitted. RCS messages are supported on some devices
                and are delivered using mobile data or Wi-Fi.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTR"
              aria-expanded="true"
              aria-controls="collapseTR">
              <i class="icon-attention text-accent-a2"></i> Text Replaced
            </button>
          </h2>
          <div id="collapseTR" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>The SMS has been delivered to our test number with the Text modified.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSIR"
              aria-expanded="true"
              aria-controls="collapseSIR">
              <i class="icon-attention text-accent-a2"></i> Sender ID replaced
            </button>
          </h2>
          <div id="collapseSIR" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>The SMS has been delivered to our test number with the Sender ID modified.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseRcsTSIR"
              aria-expanded="true"
              aria-controls="collapseRcsTSIR">
              <i class="icon-rcs-text-replaced text-accent-a2"></i> RCS Text or Sender ID Replaced
            </button>
          </h2>

          <div id="collapseRcsTSIR" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>
                The RCS message has been delivered to our test number with Sender ID or Text modified. RCS messages are supported on some devices and
                are delivered using mobile data or Wi-Fi.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item" *ngIf="showFlashCallHelp">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFlashCall"
              aria-expanded="true"
              aria-controls="collapseFlashCall">
              <i class="icon-flash-call"></i> Flash call
            </button>
          </h2>
          <div id="collapseFlashCall" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>
                The SMS was not received on our test number, but the test number received an incoming call with a Caller ID that contains the Test ID
                Text. This gives a strong indication that the SMS was delivered as a flash call instead of an SMS. This status is only available for
                tests created with flash call detection.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseNegative"
              aria-expanded="true"
              aria-controls="collapseNegative">
              <i class="icon-negative text-accent-a2"></i> Negative
            </button>
          </h2>
          <div id="collapseNegative" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>We were not able to confirm the delivery of the test SMS within the TTL.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTNNA"
              aria-expanded="true"
              aria-controls="collapseTNNA">
              <i class="icon-test-number-not-available text-accent-a2"></i> Test number not available
            </button>
          </h2>
          <div id="collapseTNNA" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>
                The test number to which this test SMS was sent has become unavailable - temporary status. <br />
                The test will stay active until TTL expires and its status can be updated.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTNO"
              aria-expanded="true"
              aria-controls="collapseTNO">
              <i class="icon-negative text-accent-a2"></i> Test number offline
            </button>
          </h2>
          <div id="collapseTNO" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>
                We were not able to confirm the delivery of the test SMS within the TTL and the test number was unavailable when the TTL expired.<br />You
                will not be billed for this test.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseNO"
              aria-expanded="true"
              aria-controls="collapseNO">
              <i class="icon-network-offline text-error-r3"></i> Network Offine
            </button>
          </h2>
          <div id="collapseNO" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>The network for which this test was issued was offline when the test was created.<br />You will not be billed for this test.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseIE"
              aria-expanded="true"
              aria-controls="collapseIE">
              <i class="icon-bug-red text-error-r3 ms-0_2"></i> Internal Error
            </button>
          </h2>
          <div id="collapseIE" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>
                Our systems have suffered an internal error and your test could not be completed. <br />
                Please contact TelQ Support if this happens. <br />You will not be billed for this test.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSCO"
              aria-expanded="true"
              aria-controls="collapseSCO">
              <i class="icon-smpp-connection-offline text-error-r3"></i> SMPP Connection offline
            </button>
          </h2>
          <div id="collapseSCO" class="accordion-collapse collapse" data-bs-parent="#accordionReceiptStatus">
            <div class="accordion-body">
              <div>
                The SMPP connection of the selected supplier was offline when the test was created.
                <br />You will not be billed for this test.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="smpp-dlr-status">
      <h3>SMPP DLR status</h3>
      <div class="accordion mt-20" id="accordionSmppdlr">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseScheduled"
              aria-expanded="true"
              aria-controls="collapseScheduled">
              <i class="far fa-meh text-accent-a2"></i> Scheduled
            </button>
          </h2>
          <div id="collapseScheduled" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              The message is scheduled
              <div>
                Delivery has not yet been initiated. A message submitted with a scheduled delivery time may return this state when queried. This value
                was added for V5.0 of SMPP and V3.4 and earlier MCs are likely to return ENROUTE for scheduled messages.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsePending"
              aria-expanded="false"
              aria-controls="collapsePending">
              <i class="far fa-meh text-accent-a2"></i> Pending
            </button>
          </h2>
          <div id="collapsePending" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              The message is pending. Delivery has not yet been initiated.
              <div>
                A message submitted with a scheduled delivery time may return this state when queried. This value was added for V5.0 of SMPP and V3.4
                and earlier MCs are likely to return ENROUTE for scheduled messages.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEnroute"
              aria-expanded="false"
              aria-controls="collapseEnroute">
              <i class="far fa-meh text-accent-a2"></i> Enroute
            </button>
          </h2>
          <div id="collapseEnroute" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              The message is in enroute state.
              <div>
                This is a general state used to describe a message as being active within the MC. The message may be in retry or dispatched to a
                mobile network for delivery to the mobile.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseDelivered"
              aria-expanded="false"
              aria-controls="collapseDelivered">
              <i class="far fa-smile text-success-s2"></i> Delivered
            </button>
          </h2>
          <div id="collapseDelivered" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              Message is delivered to destination.
              <div>The message has been delivered to the destination. No further deliveries will occur.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseExpired"
              aria-expanded="false"
              aria-controls="collapseExpired">
              <i class="far fa-frown error text-error-r3"></i> Expired
            </button>
          </h2>
          <div id="collapseExpired" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              Message validity period has expired.
              <div>
                The message has failed to be delivered within its validity period and/or retry period. No further delivery attempts will be made.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseDeleted"
              aria-expanded="false"
              aria-controls="collapseDeleted">
              <i class="far fa-frown error text-error-r3"></i> Deleted
            </button>
          </h2>
          <div id="collapseDeleted" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              Message has been deleted.
              <div>The message has been cancelled or deleted from the MC. No further delivery attempts will take place.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseUndelivered"
              aria-expanded="false"
              aria-controls="collapseUndelivered">
              <i class="far fa-frown error text-error-r3"></i> Undeliverable
            </button>
          </h2>
          <div id="collapseUndelivered" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              Message is undeliverable.
              <div>
                The message has encountered a delivery error and is deemed permanently undeliverable. No further delivery attempts will be made.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseAccepted"
              aria-expanded="false"
              aria-controls="collapseAccepted">
              <i class="far fa-meh text-accent-a2"></i> Accepted
            </button>
          </h2>
          <div id="collapseAccepted" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              Message is in accepted state (i.e. has been manually read on behalf of the subscriber by customer service)
              <div>
                This state is used to depict intervention on the MC side. Sometimes a malformed message can cause a mobile to power-off or experience
                problems. The result is that all messages to that mobile may remain queued until the problem message is removed or expires.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseUnknown"
              aria-expanded="false"
              aria-controls="collapseUnknown">
              <i class="far fa-meh text-accent-a2"></i> Unknown
            </button>
          </h2>
          <div id="collapseUnknown" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              Message is in invalid state
              <div>The message state is unknown. This may be due to some internal MC problem which may be intermediate or a permanent.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseRejected"
              aria-expanded="false"
              aria-controls="collapseRejected">
              <i class="far fa-frown error text-error-r3"></i> Rejected
            </button>
          </h2>
          <div id="collapseRejected" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              Message is in a rejected state
              <div>
                The message has been rejected by a delivery interface. The reasons for this rejection are vendor and network specific. No further
                delivery attempts will be made
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSkipped"
              aria-expanded="false"
              aria-controls="collapseSkipped">
              <i class="far fa-frown error text-error-r3"></i> Skipped
            </button>
          </h2>
          <div id="collapseSkipped" class="accordion-collapse collapse" data-bs-parent="#accordionSmppdlr">
            <div class="accordion-body">
              The message was accepted but not transmitted or broadcast on the network.
              <div>
                A skipped message is one that was deliberately ignored according to vendor or network-specific rules. No further delivery attempts
                will be made
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="internal-status">
      <h3>Internal status</h3>
      <div class="accordion mt-20" id="accordionInternaldlr">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseNDR"
              aria-expanded="true"
              aria-controls="collapseNDR">
              <i class="far fa-meh text-accent-a2"></i> No DLR Received
            </button>
          </h2>
          <div id="collapseNDR" class="accordion-collapse collapse" data-bs-parent="#accordionInternaldlr">
            <div class="accordion-body">
              <div>The SMS was submitted correctly, but we didn’t receive any deliver_sm within the set time limit (test ttl)</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsePD"
              aria-expanded="true"
              aria-controls="collapsePD">
              <i class="far fa-meh text-accent-a2"></i> Partially Delivered
            </button>
          </h2>
          <div id="collapsePD" class="accordion-collapse collapse" data-bs-parent="#accordionInternaldlr">
            <div class="accordion-body">
              <div>For concatenated messages, when we received a deliver_sm for some of the message parts, but not for all the parts</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSF"
              aria-expanded="true"
              aria-controls="collapseSF">
              <i class="far fa-frown error text-error-r3"></i> SUBMIT_SM Failed
            </button>
          </h2>
          <div id="collapseSF" class="accordion-collapse collapse" data-bs-parent="#accordionInternaldlr">
            <div class="accordion-body">
              <div>We didn’t receive the positive submit_sm_resp back from the SMS platform within the time limit (60s)</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="stop-words" *ngIf="stopWords.length > 0">
      <h3>Stop words</h3>
      <div class="pills-holder stop-words-wrapper d-flex flex-wrap mt-10">
        <div class="pills-btn text-neutral-n9" *ngFor="let word of stopWords">{{ word }}</div>
      </div>
    </div>
    <div *ngIf="stopWords.length > 0" class="hr-line-dashed"></div>
  </div>
  <hr class="my-20" />
  <div class="video-wrapper">
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/V01W9lnub9Q?rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe>
  </div>
</ng-template>

<ng-template #manualTestingModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Manual Testing Information</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="row">
      <h3>Status</h3>
      <ul class="status d-flex flex-column my-15 gap-10">
        <li><i class="icon-wait spin"></i> Wait</li>
        <li><i class="icon-positive text-success-s2"></i> Positive</li>
        <li><i class="icon-rcs-positive text-success-s2"></i> RCS Positive</li>
        <li><i class="icon-test-number-not-available text-accent-a2"></i> Test number not available</li>
        <li><i class="icon-negative text-accent-a2"></i> Test number offline</li>
        <li><i class="icon-network-offline text-error-r3"></i> Network offline</li>
        <li><i class="icon-bug-red text-error-r3 ms-0_2"></i> Internal error</li>
        <li><i class="icon-negative text-error-r3"></i> Negative</li>
      </ul>
    </div>
    <div class="row mb-20">
      <div class="col-md-12">
        <hr class="my-20" />
        <div class="alert alert-danger">
          <b class="text-danger">IMPORTANT:</b> please always include your Test ID Text when you are sending tests, otherwise your test results will
          not be displayed.
        </div>
        <br />
        If you have any questions, please don't hesitate to contact us directly.
      </div>
    </div>
  </div>
</ng-template>

<ng-template #cliTestingModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">CLI Information</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="receipt-statuses mb-20">
      <h3>Statuses</h3>
      <div class="accordion mt-20" id="accordionStatus">
        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseWait"
              aria-expanded="true"
              aria-controls="collapseWait">
              <i class="icon-wait spin"></i>Wait
            </button>
          </h2>
          <div id="collapseWait" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>
                The test has been created and is waiting for you to initiate a call from your system to the provided test number within the
                time-to-live (TTL). The remaining TTL is displayed next to the status. If you do not initiate a call from your system within the TTL,
                the test will automatically be marked as expired.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseReceived"
              aria-expanded="true"
              aria-controls="collapseReceived">
              <i class="far fa-smile text-success-s2"></i>Received
            </button>
          </h2>
          <div id="collapseReceived" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>
                The call has been delivered to the destination and was processed by our system. In the test details, you will see the number the call
                was sent to, as well as the caller ID and the delivery time from the moment the test was created.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTR"
              aria-expanded="true"
              aria-controls="collapseTR">
              <i class="far fa-frown error text-error-r3"></i>Expired
            </button>
          </h2>
          <div id="collapseTR" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>The call has failed to be delivered within its TTL. No further delivery attempts will be made.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSIR"
              aria-expanded="true"
              aria-controls="collapseSIR">
              <i class="icon-bug-red text-error-r3"></i>Internal Error
            </button>
          </h2>
          <div id="collapseSIR" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>
                Our systems have suffered an internal error and your test could not be completed. Please contact TelQ Support if this happens.
                <br />You will not be billed for this test.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseNegative"
              aria-expanded="true"
              aria-controls="collapseNegative">
              <i class="icon-negative text-accent-a2"></i>Test number offline
            </button>
          </h2>
          <div id="collapseNegative" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>
                We were not able to confirm the delivery of the test call within the TTL and the test number was unavailable when the TTL expired.
                <br />You will not be billed for this test.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTNNA"
              aria-expanded="true"
              aria-controls="collapseTNNA">
              <i class="icon-network-offline text-error-r3"></i>Network Offline
            </button>
          </h2>
          <div id="collapseTNNA" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>
                The network for which this test was issued was offline when the test was created.
                <br />You will not be billed for this test.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #sipCliTestingModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">SIP testing information</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="receipt-statuses mb-20">
      <h3>SIP status</h3>
      <div class="accordion mt-20" id="accordionSIPStatus">
        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseRinging"
              aria-expanded="true"
              aria-controls="collapseRinging">
              180 - Ringing
            </button>
          </h2>
          <div id="collapseRinging" class="accordion-collapse collapse" data-bs-parent="#accordionSIPStatus">
            <div class="accordion-body ps-12">
              <div>The destination device is ringing, but the call has not yet been answered.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOk"
              aria-expanded="true"
              aria-controls="collapseOk">
              200 - OK
            </button>
          </h2>
          <div id="collapseOk" class="accordion-collapse collapse" data-bs-parent="#accordionSIPStatus">
            <div class="accordion-body ps-12">
              <div>
                The call was successfully received and accepted by the destination. This status usually means the call was answered, either by a
                person, voicemail, or an automated system.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseBlacklisted"
              aria-expanded="true"
              aria-controls="collapseBlacklisted">
              403 – Phone Number is Blacklisted
            </button>
          </h2>
          <div id="collapseBlacklisted" class="accordion-collapse collapse" data-bs-parent="#accordionSIPStatus">
            <div class="accordion-body ps-12">
              <div>
                The call was blocked by the destination system. The number you are trying to call is blacklisted or restricted on the recipient’s
                side.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseNotFound"
              aria-expanded="true"
              aria-controls="collapseNotFound">
              404 - Not Found
            </button>
          </h2>
          <div id="collapseNotFound" class="accordion-collapse collapse" data-bs-parent="#accordionSIPStatus">
            <div class="accordion-body ps-12">
              <div>
                The destination number could not be located. The number may be invalid, incorrectly formatted, or unavailable at the time of the
                request.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTemporaryUnavailable"
              aria-expanded="true"
              aria-controls="collapseTemporaryUnavailable">
              480 – Temporarily Unavailable
            </button>
          </h2>
          <div id="collapseTemporaryUnavailable" class="accordion-collapse collapse" data-bs-parent="#accordionSIPStatus">
            <div class="accordion-body ps-12">
              <div>
                The destination is currently unreachable. This may be due to network issues, unregistered endpoints, or the recipient being offline.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseCallDoesNotExist"
              aria-expanded="true"
              aria-controls="collapseCallDoesNotExist">
              481 – Call/Transaction Does Not Exist
            </button>
          </h2>
          <div id="collapseCallDoesNotExist" class="accordion-collapse collapse" data-bs-parent="#accordionSIPStatus">
            <div class="accordion-body ps-12">
              The SIP server could not find the session or transaction related to the call. This can occur if the call was already terminated or never
              correctly initiated.
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseBusyHere"
              aria-expanded="true"
              aria-controls="collapseBusyHere">
              486 – Busy Here
            </button>
          </h2>
          <div id="collapseBusyHere" class="accordion-collapse collapse" data-bs-parent="#accordionSIPStatus">
            <div class="accordion-body ps-12">
              <div>The destination number is currently busy and unable to accept the call. The call was rejected because the line was in use.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseRequestTerminated"
              aria-expanded="true"
              aria-controls="collapseRequestTerminated">
              487 – Request Terminated
            </button>
          </h2>
          <div id="collapseRequestTerminated" class="accordion-collapse collapse" data-bs-parent="#accordionSIPStatus">
            <div class="accordion-body ps-12">
              <div>
                The call attempt was canceled before being fully completed. Although 487 is technically an error code in SIP, in our context it often
                indicates <b>a successful test</b>, where the call was correctly <b>received, detected, and rejected</b> by our test device as
                expected.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseLimitExceeded"
              aria-expanded="true"
              aria-controls="collapseLimitExceeded">
              500 – Trunk CPS Limit Exceeded
            </button>
          </h2>
          <div id="collapseLimitExceeded" class="accordion-collapse collapse" data-bs-parent="#accordionSIPStatus">
            <div class="accordion-body ps-12">
              <div>
                The number of calls per second (CPS) sent exceeded the allowed limit. Please review and adjust the CPS value in your SIP trunk
                configuration and server.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="receipt-statuses mb-20">
      <h3>Receipt status</h3>
      <div class="accordion mt-20" id="accordionStatus">
        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseWait"
              aria-expanded="true"
              aria-controls="collapseWait">
              <i class="icon-wait spin"></i>Wait
            </button>
          </h2>
          <div id="collapseWait" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>The test is awaiting the SIP call to be received.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseReceived"
              aria-expanded="true"
              aria-controls="collapseReceived">
              <i class="far fa-smile text-success-s2"></i>Received
            </button>
          </h2>
          <div id="collapseReceived" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>
                The call has been delivered to the destination and was processed by our system. In the test details, you will see the number the call
                was sent to, as well as the caller ID and the receipt time from the moment the test was created.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseCallerIdReplaced"
              aria-expanded="true"
              aria-controls="collapseCallerIdReplaced">
              <i class="icon-attention text-accent-a2"></i>Caller ID Replaced
            </button>
          </h2>
          <div id="collapseCallerIdReplaced" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>The call has been delivered to our test number with the Caller ID modified.</div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTR"
              aria-expanded="true"
              aria-controls="collapseTR">
              <i class="far fa-frown error text-error-r3"></i>Expired
            </button>
          </h2>
          <div id="collapseTR" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>
                The call has failed to be received within its TTL. No further call attempts should be made. This status will appear if our test number
                didn’t detect the receipt of the call within the TTL.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSIR"
              aria-expanded="true"
              aria-controls="collapseSIR">
              <i class="icon-bug-red text-error-r3"></i>Internal Error
            </button>
          </h2>
          <div id="collapseSIR" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>
                Our systems have suffered an internal error and your test could not be completed. Please contact TelQ Support if this happens.
                <br />You will not be billed for this test.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseNegative"
              aria-expanded="true"
              aria-controls="collapseNegative">
              <i class="icon-negative text-accent-a2"></i>Test number offline
            </button>
          </h2>
          <div id="collapseNegative" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>
                We were not able to confirm the receipt of the test call within the TTL and the test number was unavailable when the TTL expired.
                <br />You will not be billed for this test.
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header cp">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTNNA"
              aria-expanded="true"
              aria-controls="collapseTNNA">
              <i class="icon-network-offline text-error-r3"></i>Network Offline
            </button>
          </h2>
          <div id="collapseTNNA" class="accordion-collapse collapse" data-bs-parent="#accordionStatus">
            <div class="accordion-body">
              <div>
                The network for which this test was issued was offline when the test was created.
                <br />You will not be billed for this test.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mobileOriginatedModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Mobile Originated Testing</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div>
      <div class="header">
        <h3>Sent status</h3>
        <span> - the SMS submission status we receive from our testing device</span>
      </div>
      <ul class="status d-flex flex-column my-15 gap-10">
        <li>
          <strong><i class="icon-wait spin me-10"></i> Wait</strong><br />
          <div class="mt-10 mb-10">Waiting for status updates</div>
        </li>
        <li>
          <strong><i class="icon-done text-success-s2 me-10"></i> Sent</strong><br />
          <div class="mt-10 mb-10">MO SMS was sent successfully from our test number</div>
        </li>
        <li>
          <strong><i class="icon-negative text-error-r2 me-10"></i> Sent Error</strong><br />
          <div class="mt-10 mb-10">A known error was returned when attempting to send the MO SMS (see test details for more information)</div>
        </li>
        <li>
          <strong><i class="far fa-frown text-error-r3 me-10"></i> Expired</strong><br />
          <div class="mt-10 mb-10">We received no Sent status updates within the test TTL</div>
        </li>
        <li>
          <strong><i class="icon-enroute-unknown text-accent-a2 me-10"></i> Unknown Error</strong><br />
          <div class="mt-10 mb-10">An unknown Sent error was returned when attempting to send the MO SMS (see test details for more information)</div>
        </li>
        <li>
          <strong><i class="icon-test-number-not-available text-accent-a2 me-10"></i> Test Number not available</strong><br />
          <div class="mt-10 mb-10">The test number is not available (temporary status)</div>
        </li>
        <li>
          <strong><i class="icon-negative text-accent-a2 me-10"></i> Test Number Offline</strong><br />
          <div class="mt-10 mb-10">The test number remained unavailable until the test TTL expired, you will not be billed for this test</div>
        </li>
        <li>
          <strong><i class="icon-network-offline text-error-r3 me-10"></i> Network Offline</strong><br />
          <div class="mt-10 mb-10">The network has become unavailable, you will not be billed for this test</div>
        </li>
        <li>
          <strong><i class="icon-bug-red text-error-r3 me-10 ms-0_2"></i> Internal Error</strong><br />
          <div class="mt-10 mb-10">An error on our side prevented the test to be completed, please contact our support if this happens</div>
        </li>
      </ul>

      <hr class="my-20" />

      <div class="header">
        <h3>DLR status</h3>
        <span> - the delivery status that we receive from the MNO</span>
      </div>
      <ul class="status d-flex flex-column my-15 gap-10">
        <li>
          <strong><i class="icon-wait spin me-10"></i> Wait</strong>
          <div class="mt-10 mb-10">Waiting for status updates</div>
        </li>
        <li>
          <strong><i class="far fa-smile text-success-s2 me-10"></i> Delivered</strong>
          <div class="mt-10 mb-10">We received a positive DLR for the MO SMS</div>
        </li>
        <li>
          <strong><i class="far fa-frown text-error-r3 me-10"></i> Expired</strong>
          <div class="mt-10 mb-10">We received no DLR status updates within the test TTL</div>
        </li>
        <li>
          <strong><i class="icon-bug-red text-error-r3 me-10 ms-0_2"></i>Internal Error</strong>
          <div class="mt-10 mb-10">An unknown DLR error was returned (see test details for more information)</div>
        </li>
      </ul>
    </div>

    <hr class="my-20" />

    <div class="alert alert-info" role="alert">
      <b>Please note</b> that not all the MNOs consistently support DLR statuses and you might not receive them for some networks.
    </div>
  </div>
</ng-template>

<ng-template #sessionsModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Connection Information</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body info-content">
    Please follow these simple steps in order to integrate with TelQ via SMPP:
    <ul class="d-flex flex-column my-15 gap-10">
      <li>
        1. Ask your supplier or set up in your system yourself (preferable option) an SMPP user account and whitelist the IP address of our platform:
        52.29.63.229.
        <ul class="d-flex flex-column my-15 gap-10 ms-20">
          <li>
            1.1 In case you set up the account yourself, please ensure that the traffic is routed via the supplier which you would like to test.
          </li>
        </ul>
      </li>
      <li>
        2. Create a new connection in the "Connections" section of TelQ test number platform, using the username and password which have been created
        by you or your supplier.
      </li>
      <li>
        3. Check whether the bind has been established (green indicator) and if so, you are ready to go, click on "Live number testing" and start
        sending your tests!
      </li>
    </ul>
    <hr class="my-20" />
    If you have any issues establishing an SMPP connection towards your platform or the platform of your supplier, please don't hesitate to let us
    know.
    <hr class="my-20" />
    <a href="/img/smpp_integration_service_type.png" target="_blank" title="Service type integration (Click for full size)">
      <img src="/img/smpp_integration_service_type.png" alt="Service type integration" class="w-100" />
    </a>
    <hr class="my-20" />
    <a href="/img/smpp_integration_without_service_type.png" target="_blank" title="SMPP integration without service type (Click for full size)">
      <img src="/img/smpp_integration_without_service_type.png" alt="SMPP integration without service type" class="w-100" />
    </a>
    <hr class="my-20" />
    <div class="mb-15">
      <iframe
        width="100%"
        height="315"
        src="https://www.youtube.com/embed/Fhz50U6UBJo?rel=0"
        frameborder="0"
        allow="encrypted-media"
        allowfullscreen></iframe>
    </div>
  </div>
</ng-template>

<ng-template #appInfoModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">App info</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <textarea readonly [value]="appInfo" class="form-control mb-10" style="min-height: 350px"></textarea>
    <div class="text-right mb-10">
      <button class="btn btn-primary" (click)="appInfoCopy()">Copy</button>
    </div>
  </div>
</ng-template>
